export enum ContractPeriodEnum {
  SIX_MONTH,
  TWELVE_MONTH,
}
